import React from "react";
import "./Featured.scss";

const Featured = () => {
    return (
        <section className="featured container">
            <div className="title">Featured</div>
            <div className="featured__img">#Off the Wall</div>
        </section>
    );
};

export default Featured;
